import './Form.sass'
import convert from '../../assets/img/matter/convert.png'
import ReactInputMask from 'react-input-mask'
import { useState } from 'react'
import api from '../../lib/api'
import { useFormContext } from '../../contexts/formContext'
import { useEffect } from 'react'

const experienceArr = [
    'Новичок (до 1 года)',
    'Начинающий (1-3 года)',
    'Профи (3-6 лет)',
    'Эксперт (более 6 лет)'
]

export default function Form({ eventId }) {
    const [fio, setFio] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [experience, setExperience] = useState()
    const [events, setEvents] = useState()
    const [event, setEvent] = useState(eventId)
    const [vd, setVd] = useState(false)
    const [status, setStatus] = useState(false)

    const form = useFormContext()

    const send = () => {
        if (!fio || !phone || !email)
            setVd(true)
        else
            api
                .service('requests')
                .create({
                    event,
                    fio,
                    phone,
                    email,
                    experience
                })
                .then(() => setStatus(true))
    }

    useEffect(() => {
        api.service('events').find()
            .then(setEvents)
    }, [])

    return (
        <section className="section-matter">
            <div className="container">
                <div className="matter">
                    <div id="form" className="matter-block" ref={form}>
                        {status ?
                            <div className="matter-form">
                                <p>Заявка успешно отправлена</p>
                            </div>
                            :
                            <div className="matter-form">
                                <h2 className="matter-title title">
                                    ЗАРЕГИСТРИРОВАТЬСЯ
                                </h2>
                                <input
                                    required
                                    placeholder="Ваше ФИО"
                                    type="text"
                                    className="matter-input matter-input__all"
                                    value={fio}
                                    onChange={(e) => setFio(e.target.value)}
                                    style={vd && fio == '' ? { borderColor: '#df2a31' } : {}}
                                />
                                <div className="matter-input__row">
                                    <ReactInputMask
                                        required
                                        mask="+7 999 999 99 99"
                                        maskChar=" "
                                        placeholder="+7 ___-___-__"
                                        className="matter-input matter-input__dop"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        style={vd && phone == '' ? { borderColor: '#df2a31' } : {}}
                                    />
                                    {/* <input required placeholder="+7 ___-___-__" type="tel" className="matter-input matter-input__dop" /> */}
                                    <input
                                        required
                                        placeholder="Ваш e-mail"
                                        type="email"
                                        className="matter-input matter-input__dop"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        style={vd && email == '' ? { borderColor: '#df2a31' } : {}}
                                    />
                                </div>
                                <select className="matter-input matter-input__all matter-select" value={event} onChange={(e) => setEvent(e.target.value)}>
                                    <option value="Не указан" selected disabled>Мероприятие</option>
                                    {events &&
                                        events.data.map(item => (
                                            <option value={item._id} key={item._id}>{item.label}</option>
                                        ))}
                                </select>
                                <select className="matter-input matter-input__all matter-select" value={experience} onChange={(e) => setExperience(e.target.value)}>
                                    <option value="Не указан" selected disabled>Опыт работы</option>
                                    {experienceArr.map(item => (
                                        <option value={item} key={item}>{item}</option>
                                    ))}
                                </select>

                                <div className="matter-check">
                                    <input id="check" type="checkbox" className="matter-check__input" />
                                    <label for="check" className="matter-check__label">Я согласен на <a href="https://www.danogips.ru/politika_konfidenczialnosti.html">обработку персональных данных</a></label>
                                </div>
                                <button className="matter-button" onClick={send}>
                                    отправить
                                </button>
                            </div>
                        }
                        <img src={convert} alt="convert" className="matter-convert" />
                    </div>
                </div>
            </div>
        </section>
    )
}